import React, { useEffect, useMemo, useState, useRef } from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  horizontalListSortingStrategy,
} from '@dnd-kit/sortable';
import { SortableItem } from '../components/SortableItem'; // You'll need to create this component
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../styles/member.css';
import {
  getMemberTransactions, membersessions,
  createMemberWidget, getMemberWidget,
  downloadclassinvoice,
  getClassTransactionbyNumber,
  getUpcomingSessionbyMid,
  getAnnouncements,
  getGBussinessInfo,
  getClassBookingInfo,getPlans
} from '../../services/memberApiServices';
import moment from "moment";
import { useCart } from '../components/CartContext';
import { Link, useNavigate } from 'react-router-dom';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardImage, MDBTypography, MDBBtn, MDBBadge, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalBody, MDBModalTitle, MDBIcon, MDBListGroup, MDBListGroupItem } from 'mdb-react-ui-kit';
import CreateMember from "../../components/createMember";
import ViewAnnouncement from '../components/ViewAnnouncement';
import dashbordbg from '../assets/images/dashboard-bg.png';
import Booksessions from '../components/Booksessions';
import ftinessloader from '../../memberportal/assets/images/loader.gif';
import { BasePlanName } from '../../utils/BasePlanName';

const MemberDashboard = () => {
  const { getMemberId, getGymId, getMemberNumber, handleReload } = useCart();
  const [memberData, setMemberData] = useState({});
  const [sessionData, setSessionData] = useState([]);
  const [showWidgetPanel, setShowWidgetPanel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editMember, setEditMember] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const toggleEdit = () => { setEditMember(!editMember) }
  const navigate = useNavigate();
  const [classTrans, setClassTrans] = useState([]);
  const [filteredClassTrans, setFilteredClassTrans] = useState(null);
  // Default widgets
  const defaultWidgets = [
    { id: 'upcomingsessions', name: 'Upcoming Sessions', enabled: true },
    { id: 'membership', name: 'Membership Details', enabled: true },
    { id: 'attendance', name: 'Attendance Stats', enabled: true },
    { id: 'profile', name: 'Member Profile', enabled: true },
    { id: 'health', name: 'Health Metrics', enabled: false },
    { id: 'session', name: 'Next Session', enabled: false },
    { id: 'actions', name: 'Quick Actions', enabled: false },
    { id: 'announcements', name: 'Announcements', enabled: false },
    { id: 'payment', name: 'Payment Status', enabled: false },

    // { id: 'progress', name: 'Your Progress', enabled: false }
  ];

  const [widgetinfo, setWidgetinfo] = useState(null);
  const [widgets, setWidgets] = useState([]);
  const [unchangedwidget, setUnchangedwidget] = useState([]);
  const [announcements, setAnnouncements] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [showAllAnnouncements, setShowAllAnnouncements] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [selectedevent, setSelectedevent] = useState(null)
  const [bussinessinfo, setbusinessinfo] = useState(null)
  const [invoiceCheck, setInvoiceCheck] = useState(false)
  const [bookaClass, setbookaClass] = useState(false);
  const [success, setSuccess] = useState(false)
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [plans, setPlans] = useState([]);
  const [scheduleInfo, setScheduleInfo] = useState([]);
  const [classes, setClasses] = useState([]);
  const [policyData, setPolicyData] = useState([]);
  const [trainerData, setTrainerData] = useState([]);
  const [planss, setPlanss] = useState("");
  console.log("planss", planss)


  useEffect(() => {
    async function fetchData() {

      const response = await getClassBookingInfo(getGymId(), "class");
      if (!response || response === "false") {
        return;
      }

      const tempData = await response.json();
      console.log(tempData, "tempData");

      const currentDate = new Date();

      const filteredSchedules = (tempData?.scheduleinfo || []).filter(schedule => {
        const startDate = new Date(schedule?.startdate);
        const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

        const diffInMs = startDate - currentDate;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        const includeEvent = Math.abs(diffInDays) <= visibledaysbefore;

        return includeEvent;
      });

      setPlans(tempData?.plansinfo || []);
      setScheduleInfo(filteredSchedules);
      setClasses(tempData?.classinfo || []);
      setPolicyData(tempData?.cancelationinfo || []);
      setTrainerData(tempData?.staffinfo || []);
    }
    if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
      navigate('/memberlogin', { state: { path: "/memberdashboard" } })
    } else {
      if (getGymId()) {
        fetchData();
      }
    }

  }, [refresh]);


  useEffect(() => {
    async function fetchPlans() {
      try {
        const loggedUser = JSON.parse(localStorage.getItem("memberinfo"));
        const planResponse = await getPlans(loggedUser.gymid);

        if (!planResponse || planResponse === "false") {
          //   setApiError(true);
        } else {
          const plans = await planResponse.json();
          if (plans) {
            setPlanss(plans);
          }
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    }

    fetchPlans();

  }, [getMemberId, refresh, sessionData, classTrans, widgets, isLoading]);



  let events = useMemo(() => {
    if (!Array.isArray(scheduleInfo) || !Array.isArray(classes) || !Array.isArray(trainerData) || !Array.isArray(policyData)) {
      return [];
    }

    return scheduleInfo
      .filter(schedule => schedule && schedule.classid && schedule.startdate && schedule.enddate)
      .sort((a, b) => {
        const dateA = new Date(a.startdate);
        const dateB = new Date(b.startdate);

        if (dateA.getTime() !== dateB.getTime()) {
          return dateA.getTime() - dateB.getTime();
        }

        const timeA = moment(a.timeslot || "00:00 AM", "hh:mm A");
        const timeB = moment(b.timeslot || "00:00 AM", "hh:mm A");

        return timeA.diff(timeB);
      })
      .map(schedule => {
        const classInfo = classes.find(cls => cls?._id === schedule.classid) || {};
        const trainer = trainerData.find(tr => tr?._id === schedule.trainerid) || {};
        const policy = policyData.find(pol => pol?._id === schedule.cancellationpolicyid) || {};
        const duration = parseInt(classInfo.duration, 10) || 0;

        const startMoment = moment(schedule?.timeslot, "hh:mm A");
        const endMoment = startMoment.clone().add(duration, 'minutes');
        const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : '';
        const membership = classInfo?.membershipdiscount?.length > 0 ? classInfo?.membershipdiscount.filter(data => data.checked) : "";

        return {
          id: schedule._id,
          title: classInfo.name || "Unknown Class",
          start: new Date(schedule.startdate),
          end: new Date(schedule.enddate),
          isprivate: schedule?.isprivate ? schedule.isprivate : false,
          extendedProps: {
            price: classInfo.price || 0,
            trainer: `${trainer.firstname} ${trainer.lastname}` || "Unknown Trainer",
            slotsBooked: schedule.bookedslots || 0,
            slotsRemaining: schedule.totalslots ? schedule.totalslots : classInfo.slots || 0,
            startTime: startMoment.format("hh:mm A"),
            endTime: endMoment.format("hh:mm A"),
            cancellationPolicy: cancellationPolicy,
            eventType: !schedule.onetime ? `Recurring(${schedule?.recurrence?.recurrencetype})` : "One-Time",
            description: classInfo?.description,
            membershipdiscount: membership,
            scheduleinfo: schedule,
            classInfo: classInfo,
            trainerInfo: trainer,
            category: classInfo.category || '',
            duration: duration
          }
        };
      });
  }, [scheduleInfo, classes, trainerData, policyData]);


  const handleCallback = () => {
    setbookaClass(false)
    // setSelectedMembers([])
    setRefresh(true)
    setInvoiceCheck(false)
    setSuccess(true)

  }

  const togglebookaClass = () => {
    setbookaClass(!bookaClass);
  }
  const handleclassevent = (event) => {
    setSelectedevent(event?.extendedProps)
    togglebookaClass()
  }



  useEffect(() => {
    const fetchBusiness = async () => {
      if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
        navigate('/memberlogin', { state: { path: "/memberdashboard" } })
        return;
      }
      if (getGymId() == -1) {
        return;
      }
      const response = await getGBussinessInfo(
        getGymId()
      );
      if (!response || response === "false") {
        return;
      }
      const recinfo = await response.json();
      if (recinfo) {
        setbusinessinfo(recinfo)
      }
    };

    fetchBusiness();
  }, [getGymId]);

  const displayEvents = events;
  const slotLimit = (event) => {
    return event?.extendedProps?.slotsRemaining - event?.extendedProps?.slotsBooked
  }


  // Set up sensors for dnd-kit
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const loadDashboardLayout = async () => {
    try {
      const memberId = getMemberId();
      const gymId = getGymId();
      if (!memberId || !gymId) {
        setWidgets(defaultWidgets);
        return;
      }
      if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
        navigate('/memberlogin', { state: { path: "/memberdashboard" } })
        return
      }
      const response = await getMemberWidget(gymId, memberId);
      if (response && response !== "false") {
        const widgetData = await response.json();
        console.log(widgetData, 'widgetData');

        if (widgetData && widgetData.length > 0) {
          setWidgets(widgetData[0].widgetsinfo);
          setUnchangedwidget(widgetData[0].widgetsinfo || defaultWidgets);
          setWidgetinfo(widgetData[0]); // Store the full widget info
        } else {
          // If no saved layout, use defaults
          setWidgets(defaultWidgets);
          setUnchangedwidget(defaultWidgets);
          setWidgetinfo(null);
        }
      } else {
        // If API call fails, use defaults
        setWidgets(defaultWidgets);
        setUnchangedwidget(defaultWidgets);
        setWidgetinfo(null);
      }
    } catch (error) {
      console.error("Error loading dashboard layout:", error);
      setWidgets(defaultWidgets);
      setUnchangedwidget(defaultWidgets);
      setWidgetinfo(null);
    } finally {
      setIsLoading(false);
      setRefresh(false);
    }
  };
  const fetchData = async () => {
    try {
      if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
        navigate('/memberlogin', { state: { path: "/memberdashboard" } })
        return
      }
      const memberResponse = await getMemberTransactions(getMemberId());
      if (memberResponse && memberResponse !== "false") {
        const memberData = await memberResponse.json();
        setMemberData(memberData && memberData.length > 0 ? memberData[0] : {});
      }

      const sessionResponse = await membersessions(getMemberId());
      if (sessionResponse && sessionResponse !== "false") {
        const sessionData = await sessionResponse.json();
        setSessionData(sessionData || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchClassTransactions = async () => {
    try {
      if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
        navigate('/memberlogin', { state: { path: "/memberdashboard" } })
        return
      }
      const update = {
        number: getMemberNumber(),
        memberid: getMemberId()
      }
      const response = await getUpcomingSessionbyMid(
        getGymId(),
        update
      );

      if (response && response !== "false") {
        const data = await response.json();

        setClassTrans(data);
        const upcomingSessions = data.filter(item => {
          const startDate = new Date(item.startdate);
          return startDate > new Date();
        });


        if (upcomingSessions.length > 0) {
          setFilteredClassTrans(upcomingSessions[0]);
        } else {
          setFilteredClassTrans(null);
        }
      }
    } catch (error) {
      console.error("Error fetching class transactions:", error);
    } finally {
      // setIsLoadingSessions(false);
    }
  };

  const fetchAnnounceData = async () => {
    const res = await getAnnouncements(getGymId())
    if (!res || res == "false") {
      return
    }
    const recinfo = await res.json();
    // console.log(recinfo);
    if (recinfo.length > 0) {
      setAnnouncements(recinfo)
    }

  }

  console.log(memberData, 'memberData');


  useEffect(() => {
    if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
      navigate('/memberlogin', { state: { path: "/memberdashboard" } })
    } else {
      if (getMemberId() && getGymId()) {
        setIsLoading(true);
        setWidgets([]);
        setWidgetinfo(null);
        setUnchangedwidget([]);
        loadDashboardLayout();
        fetchData();
        fetchClassTransactions();
        fetchAnnounceData();
      }
    }


  }, [getMemberId(), getGymId(), getMemberNumber, refresh]);


  let membership = {};
  let remainingSessions = "N/A";

  // Safely access transaction data
  const transactions = memberData?.trans || [];
  const activeTransactions = transactions.filter(obj =>
    obj.isplan === "1" && new Date() < new Date(obj.expirydate)
  ).sort((a, b) => new Date(b.expirydate) - new Date(a.expirydate));

  const allTransactions = [...transactions].sort((a, b) =>
    new Date(b.expirydate) - new Date(a.expirydate)
  );

  // Find membership info
  if (memberData?.plan?.length > 0 && activeTransactions.length > 0) {
    membership = memberData.plan.find(item => item._id === activeTransactions[0]?.itemid) || {};
  }
  if (memberData?.plan?.length > 0) {
    membership = memberData.plan.find(item => item._id === allTransactions[0]?.itemid) || {};
  }
  if (!membership._id && memberData?.subplan?.length > 0) {
    const subplan =
      memberData.subplan.find(item => item._id === activeTransactions[0]?.itemid) ||
      memberData.subplan.find(item => item._id === allTransactions[0]?.itemid);

    if (subplan) {
      let baseName = "";
      if (subplan.baseplan) {
        baseName = BasePlanName(planss, subplan.baseplan);
      }

      membership = {
        ...subplan,
        membershiptype: "plan",
        displayName: baseName ? `${baseName}-${subplan.name}` : subplan.name,
      };
    }
  }


  if (memberData?.addons?.length > 0) {
    const addon = memberData.addons.find(item => item._id === allTransactions[0]?.itemid);
    console.log(addon, 'addon');

    if (addon) {
      membership = { ...addon, membershiptype: 'addon' };
    }
  }

  // Find session info
  if (sessionData.length > 0 && activeTransactions.length > 0) {
    const session = sessionData.find(item => item.transid === activeTransactions[0]?._id);
    remainingSessions = session?.balsessions ?? "N/A";
  }

  const calculateAttendanceStats = () => {
    console.log(memberData.attendance);

    if (!memberData?.attendance || memberData?.attendance.length === 0) {
      return {
        thisMonthCount: 0,
        currentStreak: 0,
        totalVisits: 0
      };
    }

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // 1. Filter this month's attendance
    const thisMonthAttendance = memberData.attendance.filter(item => {
      const date = new Date(item.intime);
      return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
    });

    // 2. Calculate current streak (only unique days)
    const uniqueDateSet = new Set(
      memberData?.attendance.map(item => {
        const date = item.intime ? new Date(item.intime) : new Date();
        return date.toISOString().split('T')[0]; // Get date string YYYY-MM-DD
      })
    );

    const sortedUniqueDates = Array.from(uniqueDateSet)
      .map(dateStr => new Date(dateStr))
      .sort((a, b) => b - a); // Newest first

    let streak = 0;
    let prevDate = null;

    for (let i = 0; i < sortedUniqueDates.length; i++) {
      const currentDate = sortedUniqueDates[i];

      if (prevDate === null) {
        streak = 1;
        prevDate = currentDate;
        continue;
      }

      const diffDays = Math.floor((prevDate - currentDate) / (1000 * 60 * 60 * 24));

      if (diffDays === 1) {
        streak++;
        prevDate = currentDate;
      } else if (diffDays > 1) {
        break; // Streak ends
      }
    }

    console.log(thisMonthAttendance, 'thisMonthAttendance');

    return {
      thisMonthCount: thisMonthAttendance.length,
      currentStreak: streak,
      totalVisits: memberData.attendance.length
    };
  };

  const attendanceStats = calculateAttendanceStats();
  // Add these new stats calculations
  const calculateBMI = () => {
    if (!memberData.height || !memberData.weight) return "N/A";
    const heightInMeters = memberData.height / 100;
    return (memberData.weight / (heightInMeters * heightInMeters)).toFixed(1);
  };

  const getNextSession = () => {
    if (!sessionData.length) return "No upcoming sessions";
    const upcoming = sessionData.filter(s => new Date(s.sessionDate) > new Date());
    if (!upcoming.length) return "No upcoming sessions";
    return moment(upcoming[0].sessionDate).format("MMM Do, h:mm a");
  };






  console.log(membership, memberData, 'membership');


  // Save layout to database when it changes
  useEffect(() => {
    if (!isLoading && widgets?.length > 0 && getMemberId()) {
      const saveLayout = async () => {
        try {
          console.log('insidesavelayout');

          const memberId = getMemberId();
          const gymid = getGymId();
          if (gymid && memberId) {
            const update = {
              widgetsinfo: widgets,
              memberid: memberId,
              gymid: gymid,
              _id: widgetinfo?._id ? widgetinfo._id : undefined // Use undefined instead of -1
            };
            await createMemberWidget(gymid, update);

            // Refresh widget info after save
            const response = await getMemberWidget(gymid, memberId);
            if (response && response !== "false") {
              const widgetData = await response.json();
              setWidgetinfo(widgetData[0]);
            }
          }
        } catch (error) {
          console.error("Error saving dashboard layout:", error);
        }
      };

      // Only save if widgets have changed
      if (JSON.stringify(widgets) !== JSON.stringify(unchangedwidget)) {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
          navigate('/memberlogin', { state: { path: "/memberdashboard" } })

        } else {
          saveLayout();
        }

      }
    }
  }, [widgets, isLoading, getMemberId(), getGymId()]);


  // dnd-kit drag handlers
  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setWidgets((items) => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
    setActiveId(null);
  };

  const handlePanelDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setWidgets((items) => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const toggleWidget = (id) => {
    console.log(id, 'id');

    const updatedWidgets = widgets.map(widget =>
      widget.id === id ? { ...widget, enabled: !widget.enabled } : widget
    );
    console.log(updatedWidgets, 'updatedWidgets');

    setWidgets(updatedWidgets);
  };

  const downloadInvoice = async (path) => {
    try {
      if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
        navigate('/memberlogin', { state: { path: "/memberdashboard" } })
        return
      }
      const update = {
        tid: activeTransactions[0]?.tId,
        bid: getGymId(),
        type: path
      }
      console.log(update, 'update');

      const response = await downloadclassinvoice(update, "user")

      const data = await response.json();
      console.log(data, "data");

      if (data.url) {
        const link = document.createElement("a");
        link.href = data.url;
        link.setAttribute("download", "filename.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error fetching signed URL", error);
    }
  }

  const cardColor = [
    { id: 'membership', class: 'dashboard-membership-card', icon: 'fa-crown', color: "#f6a821" },
    { id: 'attendance', class: 'attendance-card', icon: 'fa-chart-line', color: "#4caf50" },
    { id: 'profile', class: 'dashboard-profile-card', icon: "fa-user-tie", color: "#8d14b5ff" },
    { id: 'health', class: 'dashboard-health-card', icon: 'fa-heart', color: "#ca1c6aff" },
    { id: 'session', class: 'dashboard-session-card', icon: 'fa-calendar-alt', color: "#94d119ff" },
    { id: 'actions', class: 'dashboard-actions-card', icon: 'fa-bolt', color: "#76c52cff" },
    { id: 'announcements', class: 'dashboard-announcements-card', icon: 'fa-bullhorn', color: "#FF5722" },
    { id: 'payment', class: 'dashboard-payment-card', icon: 'fa-credit-card', color: "#1a2bc3ff" },
    { id: 'upcomingsessions', class: 'dashboard-upcoming-card', icon: 'fa-calendar-days', color: "#ff6b6b" }
  ]


  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(1);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  // --- Detect screen size and set cards per view ---
  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth < 576) {
        setCardsPerView(1); // Mobile
      } else if (window.innerWidth < 768) {
        setCardsPerView(2); // Small tablet
      } else if (window.innerWidth < 1200) {
        setCardsPerView(3); // Tablet / small laptop
      } else {
        setCardsPerView(5); // Desktop
      }
    };

    updateCardsPerView();
    window.addEventListener("resize", updateCardsPerView);

    return () => window.removeEventListener("resize", updateCardsPerView);
  }, []);

  // --- Auto-scroll functionality ---
  useEffect(() => {
    if (!displayEvents?.length) return;

    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % displayEvents.length);
      }, 3000);
    };

    startAutoScroll();
    return () => clearInterval(intervalRef.current);
  }, [displayEvents?.length]);

  const goToSlide = (index) => {
    if (!displayEvents) return;
    setCurrentSlide(index);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % displayEvents.length);
    }, 3000);
  };

  const nextSlide = () => {
    if (!displayEvents?.length) return;
    goToSlide((currentSlide + 1) % displayEvents.length);
  };

  const prevSlide = () => {
    if (!displayEvents?.length) return;
    goToSlide((currentSlide - 1 + displayEvents.length) % displayEvents.length);
  };


  const formatTimeWithColoredAMPM = (timeString) => {
    if (!timeString) return '';

    // Extract time and AM/PM
    const timePart = timeString.split(' ')[0];
    const ampmPart = timeString.split(' ')[1];

    if (!ampmPart) return timeString;

    const isAM = ampmPart.toUpperCase() === 'AM';
    const color = isAM ? '#52CC99' : '#175ca7ff';
    const backgroundColor = isAM ? 'rgba(40, 167, 69, 0.1)' : 'rgba(0, 123, 255, 0.1)';

    return (
      <>
        {timePart}
        <span style={{
          color: color,
          fontWeight: 'bold',
          padding: '2px 2px',
          borderRadius: '3px',
          marginLeft: '2px'
        }}>
          {ampmPart}
        </span>
      </>
    );
  };

  // Card components
  const cardComponents = {
    upcomingsessions: (
      <div className='position-relative'>
        <div className="dashboard-upcoming-sessions-full">
          {/* Slider */}
          <div
            ref={sliderRef}
            className="Member-slider-container"
            style={{
              display: "flex",
              overflow: "hidden",
              position: "relative",
              width: "100%",
            }}
          >
            <div
              className="Member-slider-track"
              style={{
                display: "flex",
                gap: "10px",
                transition: "transform 0.5s ease",
                transform: `translateX(-${currentSlide * (100 / cardsPerView)}%)`,
                width: `${(100 * displayEvents.length) / 100}%`,
              }}
            >
              {displayEvents && displayEvents.filter(item => new Date(item.start) > new Date() && item.isprivate !== true).length > 0 ? (
                displayEvents
                  .filter(item => new Date(item.start) > new Date() && item.isprivate !== true)
                  .map((session, index) => (
                    <div
                      key={index}
                      className={slotLimit(session) === 0 ? "upcoming-session-card-small outofsession_card" : "upcoming-session-card-small"}
                      style={{
                        flex: `0 0 calc(${100 / cardsPerView}% - 10px)`,
                        marginRight: "10px",
                      }}
                    >
                      {/* Card Content */}
                      <div className="session-card-header">
                        <div className="session-date">
                          <div className="session-day">{moment(session.start).format("DD")}</div>
                          <div className="session-month">{moment(session.start).format("MMM")}</div>
                        </div>
                        <div className={`session-status ${index === 0 ? "next-session" : ""}`}>
                          {index === 0 ? "Next" : "Upcoming"}
                        </div>
                      </div>

                      <div className="session-card-body">
                        <h5 className="session-title">{session?.title || "Fitness Class"}</h5>
                        <div className="session-detail d-flex justify-content-between">
                          <span>
                            <i className="fa-regular fa-clock"></i>
                            <span>


                              {formatTimeWithColoredAMPM(session?.extendedProps?.startTime)}-{formatTimeWithColoredAMPM(session?.extendedProps?.endTime)}
                            </span>
                          </span>
                          {/* <span className="sessions-spots-remaining">
                            <i className="fas fa-users menu-icon"></i>
                            {session?.extendedProps?.slotsBooked}/{session?.extendedProps?.slotsRemaining}
                          </span> */}
                        </div>
                        <div className="session-detail">
                          <i className="fa-regular fa-user"></i>
                          <span>{session?.extendedProps?.trainer || "N/A"}</span>
                        </div>
                        <div className="session-detail">
                          <i className="fa-solid fa-location-dot"></i>
                          <span>{session?.extendedProps?.scheduleinfo?.location || "Hyderabad"}</span>
                        </div>
                      </div>
                      <div className="session-card-footer">
                        {slotLimit(session) !== 0 ? (
                          <MDBBtn className="nav-btn" onClick={() => handleclassevent(session)}>
                            <span><i className="fa-regular fa-calendar"></i> Book Now</span>
                          </MDBBtn>
                        ) : (
                          <MDBBtn type="submit" className="nav-btn orng-btn" color="primary">
                              <span className='session_btn'> Full</span>
                          </MDBBtn>
                        )}
                      </div>
                    </div>
                  ))
              ) : (
                <div className="no-upcoming-sessions">
                  <i className="fa-regular fa-calendar-xmark"></i>
                  <h5>No upcoming sessions</h5>
                </div>
              )}
            </div>
          </div>

          {/* Indicators */}
          <div
            className="Member-slider-indicators"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {displayEvents?.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  border: "none",
                  margin: "0 5px",
                  backgroundColor: currentSlide === index ? "#7b5cfa" : "#ccc",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>
        {/* Arrows */}
        <button onClick={prevSlide} className="Member-slider-arrow Member-slider-arrow-left">
          <MDBIcon fas icon="chevron-left" />
        </button>
        <button onClick={nextSlide} className="Member-slider-arrow Member-slider-arrow-right">
          <MDBIcon fas icon="chevron-right" />
        </button>
      </div>
    ),

    membership: (

      <div className="plan-details d-block">
        <div className="plan-section">
          <label> Current Membership</label>
          <h6 className='m-0'>{membership?.displayName ? membership?.displayName : membership?.name || "No Active Plan"}</h6>
        </div>

        <div className="plan-section">
          <label> Expiry Date</label>
          <h6 className='m-0'>
            {memberData?.expirydate ? moment(memberData?.expirydate).format('MMM Do, YYYY') : "--"
            }</h6>
        </div>

        <div className="plan-section">
          <label> Sessions Left</label>
          <h6 className='m-0'>
            {remainingSessions !== "N/A" ? `${remainingSessions} Session(s)` : remainingSessions}
          </h6>

        </div>

      </div>
    ),
    attendance: (

      <div className="plan-details">
        <div className="plan-section">
          <label>This Month</label>
          <h6 className='m-0'> {attendanceStats.thisMonthCount}</h6>
        </div>
        <div className='divide'></div>
        <div className="plan-section">
          <label>Current Streak</label>
          <h6 className='m-0'>  {attendanceStats.currentStreak} {attendanceStats.currentStreak === 1 ? 'day' : 'days'}</h6>
        </div>

        <div className="plan-section">
          <label>Total Visits</label>
          <h6 className='m-0'>  {attendanceStats.totalVisits}</h6>
        </div>

      </div>

    ),
    profile: (
      <div className="plan-details">
        <div className="plan-section">
          <label>Member Since</label>
          <h6 className='m-0'> {memberData?.createdAt ? moment(memberData?.createdAt).format('MMM YYYY') : "--"}</h6>
        </div>
        <div className='divide'></div>
        <div className="plan-section">
          <label>Status</label>
          <h6 className='m-0'>   <MDBBadge color={memberData.issuspend ? "danger" : "success"} pill className="dashboard-compact-badge text-white m-0">
            {!memberData.issuspend ?
              (memberData.membershipstatus ||
                ((new Date(memberData.expirydate) < new Date()) ? "Inactive" : "Active")) :
              "Suspended"}
          </MDBBadge></h6>
        </div>

        <div className="plan-section">
          <label>BMI</label>
          <h6 className='m-0'>  {calculateBMI()}</h6>
        </div>

      </div>
    ),
    health: (
      <div className="plan-details">

        <div className="plan-section">
          <label>Weight</label>
          <h6 className='m-0'>  {memberData.weight || "--"} kg</h6>
        </div>
        <div className='divide'></div>

        <div className="plan-section">
          <label>Height</label>
          <h6 className='m-0'>  {memberData.height || "--"} cm</h6>
        </div>

        <div className="plan-section">
          <label>Blood Group</label>
          <h6 className='m-0'>   {memberData.bloodgroup || "--"}</h6>
        </div>

      </div>
    ),
    session: (
      <div className="plan-details">

        <div className="plan-section">
          <label>Upcoming</label>
          <h6 className='m-0'>  {filteredClassTrans?.class?.name ? filteredClassTrans?.class?.name : "--"}</h6>
        </div>
        <div className='divide'></div>

        <div className="plan-section">
          <label>Trainer</label>
          <h6 className='m-0'>  {filteredClassTrans?.staff?.firstname ? filteredClassTrans?.staff?.firstname + " " + filteredClassTrans?.staff?.lastname : "--"}</h6>
        </div>

        <div className="plan-section">
          <label>Location</label>
          <h6 className='m-0'>  {filteredClassTrans?.classschedule?.location ? filteredClassTrans?.classschedule?.location : "--"}</h6>
        </div>

      </div>
    ),
    actions: (
      <div className="dashboard-quick-actions w-100 px-3 py-3">
        <MDBListGroup light className='w-100 quick-list'>
          <MDBListGroupItem className='border-0 py-1' onClick={() => navigate('/availablesessions')}><i className="fa-solid fa-calendar-plus me-2"></i> Book Session</MDBListGroupItem>
          <MDBListGroupItem className='border-0 py-1' onClick={() => navigate('/memberbilling', { state: { cartItems: [membership] } })}> <i className="fa-solid fa-sync-alt me-2"></i> Renew Membership</MDBListGroupItem>
          <MDBListGroupItem className='border-0 py-1' onClick={() => setEditMember(true)}> <i className="fa-solid fa-user-edit me-1"></i> Update Profile</MDBListGroupItem>
        </MDBListGroup>

      </div>
    ),
    announcements: (
      <div className="">
        <div className="dashboard-announcements-list">
          {announcements && announcements.length > 0 ? announcements.map((announcement, index) => index < 3 && (<div className="dashboard-announcement-item">
            <div className="dashboard-announcement-icon">
              <MDBIcon icon={announcement?.icon} />
            </div>
            <div className="dashboard-announcement-content">
              <p className="dashboard-announcement-title">{announcement?.title}</p>
              <div className="dashboard-announcement-text mb-0" dangerouslySetInnerHTML={{ __html: announcement.description }} />

              <p className="dashboard-announcement-date mb-1">Posted: {new Date(announcement?.createdAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
              })}</p>
            </div>
          </div>
          )) :
            <div className="dashboard-announcement-item">

              <div className="dashboard-announcement-content">

                <div className="dashboard-announcement-text mb-0"  >
                  No Announcements Found
                </div>

              </div>
            </div>

          }

        </div>
        <button className="dashboard-view-all-btn" onClick={() => setShowAllAnnouncements(true)}>
          View All Announcements <i className="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    ),
    payment: (
      <div className="dashboard-payment-details plan-details">

        <div className="plan-section">
          <label className='d-flex align-items-center'> <div className="dashboard-status-indicator active me-1"></div> Current Membership</label>
          <h6 className='m-0 ps-3'>  ₹{
            Number(membership?.price ?? membership?.props?.[0]?.propvalue ?? 0)}</h6>
        </div>
        <div className='divide'></div>

        <div className="plan-section">
          <label>Next Payment Due</label>
          <h6 className='m-0'> {activeTransactions.length > 0 && activeTransactions[0]?.expirydate ?
            moment(activeTransactions[0].expirydate).format('MMM Do, YYYY') : "--"
          }</h6>
        </div>
        <div className='d-flex justify-content-between align-items-center w-100'>
          <div className="plan-section">
            <label>Amount Due</label>
            <h6 className='m-0'>₹{(activeTransactions && activeTransactions.length > 0 && activeTransactions[0]?.payment?.balance && activeTransactions[0]?.payment?.balance !== 0) ?
              activeTransactions[0]?.payment?.balance : 0}</h6>
          </div>
          <div className="dashboard-payment-actions">
            {((activeTransactions && activeTransactions.length > 0 && activeTransactions[0]?.payment?.balance && activeTransactions[0]?.payment?.balance !== 0) ?
              activeTransactions[0]?.payment?.balance : 0) > 0 && <button className="dashboard-pay-now-btn">
                <i className="fa-solid fa-indian-rupee-sign"></i> Pay Now
              </button>}
            <button className="dashboard-view-invoice-btn " onClick={() => downloadInvoice("membership")}>
              <i className="fa-solid fa-file-invoice"></i> View Invoice
            </button>
          </div>
        </div>
      </div>
    ),

  };

  if (isLoading) {
    return <div className="dashboard-loading"> <div><img src={ftinessloader} alt="" /> </div> <h4 className='mt-2'> Loading.....</h4></div>;
  }

  const onsubmit = () => {

  }
  const createMemberCallback = () => {
    toggleEdit()
  }

  const handleClose = () => {
    setShowAllAnnouncements(false)
  }


  const handleRefresh = () => {

    // setWidgetinfo(null)
    // setWidgets([])
    // setUnchangedwidget([])
    // setAnnouncements([])
    setRefresh(true)
    handleReload()
  }
  return (
    <>
      {!invoiceCheck && <>
        <div className="dashboard-container">
          <Sidebar active={"1"} handleRefresh={handleRefresh} />
          <div className="main-content">
            <Header title={"Home"} />
            <div className='dashboard-body'>
              <div className="dashboard-controls">
                <button
                  className="widget-customize-btn" title='Customize Widgets'
                  onClick={() => setShowWidgetPanel(!showWidgetPanel)}
                >
                  <MDBIcon fas icon="align-right me-1" />
                </button>
              </div>

              {/* Main Dashboard Area with dnd-kit */}
              {isLoading ? (
                <div className="dashboard-loading"> <div><img src={ftinessloader} alt="" /> </div> <h4 className='mt-2'> Loading.....</h4></div>
              ) : (<DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={handleDragStart}
                onDragEnd={handleDragEnd}
              >
                <SortableContext
                  items={widgets.filter(widget => widget.enabled).map(widget => widget.id)}
                  strategy={horizontalListSortingStrategy}
                >
                  <div className="dashboard-cards-container">
                    {widgets
                      .filter(widget => widget.enabled)
                      .map((widget) => (
                        <SortableItem key={widget.id} id={widget.id} className={widget.id == "upcomingsessions" ? "full-width-card" : "normal-card"}>
                          {(listeners, attributes) => (
                            <div className={`dashboard-card-wrapper`}>
                              <div className={`info-card ${cardColor.find(c => c.id === widget.id)?.class || ''}`}>
                                <h3 {...listeners} {...attributes}>
                                  <i className={`fa-solid ${cardColor.find(c => c.id === widget.id)?.icon || ''}`}
                                    style={{ color: cardColor.find(c => c.id === widget.id)?.color || '' }}></i>
                                  <div className='dashbord-titel'>
                                    <p className='m-0'>
                                      {widget.name}</p>
                                    <span className='dashboard-tagline'>Easy Access to Your Information Details</span>
                                  </div>
                                  <span className="drag-handle">
                                    <i className="fa-solid fa-grip-vertical"></i>
                                  </span>
                                </h3>
                                {cardComponents[widget.id]}
                              </div>
                            </div>
                          )}
                        </SortableItem>
                      ))}
                  </div>

                  <DragOverlay>
                    {activeId ? (
                      <div className="dashboard-card-wrapper dragging">
                        <div className={`info-card ${cardColor.find(c => c.id === activeId)?.class || ''}`}>
                          <h3 >
                            <i className={`fa-solid ${cardColor.find(c => c.id === activeId)?.icon || ''}`}
                              style={{ color: cardColor.find(c => c.id === activeId)?.color || '' }}></i>
                            {widgets.find(c => c.id === activeId)?.name}
                            <span className="drag-handle">
                              <i className="fa-solid fa-grip-vertical"></i>
                            </span>
                          </h3>
                          {cardComponents[activeId]}
                        </div>

                      </div>
                    ) : null}
                  </DragOverlay>
                  <div className='dashboard-background'>
                    <img src={dashbordbg} alt="" />
                  </div>
                </SortableContext>
              </DndContext>)}

              {/* Widget Customization Panel */}
              {showWidgetPanel && (
                <div className="widget-customization-panel">
                  <div className="panel-header">
                    <h5>Customize Dashboard</h5>
                    <button onClick={() => setShowWidgetPanel(false)}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handlePanelDragEnd}
                  >
                    <SortableContext
                      items={widgets.map(widget => widget.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <div className="widget-list">
                        {widgets.map((widget) => (
                          <SortableItem key={widget.id} id={widget.id}>
                            {(listeners) => (
                              <div className="widget-list-item">
                                <div className="widget-controls d-flex align-items-center">
                                  <span className="drag-handle" {...listeners}>
                                    <i className="fa-solid fa-grip-vertical"></i>
                                  </span>
                                  <div className='h-100 w-100 d-flex align-items-center justify-content-between'>
                                    <label htmlFor={`widget-toggle-${widget.id}`} className="fw-bold mb-2 d-block align-items-center">
                                      {widget.name}
                                    </label>
                                    <div className='d-flex align-items-center justify-content-center py-1'>
                                      <label className="switch">
                                        <input
                                          id={`widget-toggle-${widget.id}`}
                                          className="form-control"
                                          type="checkbox"
                                          name="onetime"
                                          checked={widget.enabled}
                                          onChange={() => toggleWidget(widget.id)}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </SortableItem>
                        ))}
                      </div>
                    </SortableContext>
                  </DndContext>
                </div>
              )}
            </div>

            <MDBModal tabIndex='-1' open={editMember} onClose={() => setEditMember(false)}>
              <MDBModalDialog centered size='lg'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Edit Profile</MDBModalTitle>
                    <MDBBtn className='btn-close' color='none' onClick={toggleEdit}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div>
                      <CreateMember
                        id={null}
                        index={null}
                        onsubmit={onsubmit}
                        backallback={createMemberCallback}
                        submit="0"
                        mId={getMemberId()}
                        from={"reload"}
                        path={"member"}
                        gymid={getGymId()}
                      />
                    </div>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>


            {/* All Announcements Sidebar */}
            {showAllAnnouncements && (
              <ViewAnnouncement announcements={announcements} handleClose={handleClose} />
            )}


          </div>
        </div >
      </>}
      <Booksessions invoiceCheck={invoiceCheck} handleCallback={handleCallback} bookaClass={bookaClass} setbookaClass={setbookaClass} togglebookaClass={togglebookaClass} bussinessinfo={bussinessinfo} selectedevent={selectedevent} setInvoiceCheck={setInvoiceCheck} />
    </>
  );
};

export default MemberDashboard;